import React from "react";
import "./styles.css";

const CurrencyToggle = ({setCurrency, currency, measure, setMeasure, rangeValue, handleChange}) => {
    const toggleState = currency === true ? "off" : "on";

    let toggleBtn = () => {
        const newRangeValue = currency === true ? Math.round(rangeValue * 0.6214) : Math.round(rangeValue / 0.6214);
        setCurrency(currency !== true);
        setMeasure(currency === true ? "ml" : "km");
        handleChange(newRangeValue);
    }

    return (
        <div className="currency__toggle">
            <div className="currency__toggle-wrap">
                <div className="currency__toggle-title">currency toggle</div>
                <div className={`switch ${toggleState}`} onClick={toggleBtn}/>
            </div>
        </div>
    )
}

export default CurrencyToggle;

